import { apiClient } from "./apiClientService";

let inflight = null;
let cached = undefined;
let cachedAt = 0;

/** Re-fetch storefront after this many ms (stale vendor copy in SPA). */
const STOREFRONT_CACHE_TTL_MS = 45_000;

/**
 * Clears cached `/api/vendors/storefront` response so the next load is fresh.
 * Call after vendor profile updates if you need immediate UI sync.
 */
export function clearStorefrontPublicCache() {
  cached = undefined;
  cachedAt = 0;
}

/**
 * Single-flight fetch for public storefront config (superuser / single-vendor).
 * Shared by Header and head metadata (title, favicon).
 *
 * @param {{ force?: boolean }} [opts] — `force: true` skips TTL (e.g. after navigation).
 */
export async function loadStorefrontPublic(opts = {}) {
  const force = Boolean(opts.force);
  const now = Date.now();
  if (
    !force &&
    cached !== undefined &&
    now - cachedAt < STOREFRONT_CACHE_TTL_MS
  ) {
    return cached;
  }
  if (inflight) return inflight;
  inflight = apiClient("GET", "/api/vendors/storefront", null, {
    skipLoading: true,
  })
    .then((res) => {
      cached = res ?? null;
      cachedAt = Date.now();
      return cached;
    })
    .catch(() => {
      cached = null;
      cachedAt = Date.now();
      return null;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}
